<div class="rounded" [id]="id" [ngStyle]="{'width': width, 'height': height}"></div>